export type DownloadDocumentKind =
  | 'pdf'
  | 'word'
  | 'powerpoint'
  | 'spreadsheet'
  | 'other'

function extensionFromFilename(
  filename: string | undefined
): string | undefined {
  if (!filename) return undefined
  const dotIndex = filename.lastIndexOf('.')
  if (dotIndex <= 0 || dotIndex === filename.length - 1) return undefined
  return filename.slice(dotIndex + 1).toLowerCase()
}

/** Map extension tokens and DocumentType labels to a download kind. */
function kindFromToken(
  token: string | undefined
): DownloadDocumentKind | undefined {
  if (!token) return undefined
  const type = token.toLowerCase()

  if (type === 'pdf') return 'pdf'
  if (type === 'docx' || type === 'doc' || type === 'word') return 'word'
  if (type === 'pptx' || type === 'ppt' || type === 'powerpoint') {
    return 'powerpoint'
  }
  if (
    type === 'xlsx' ||
    type === 'xlsm' ||
    type === 'xls' ||
    type === 'excel'
  ) {
    return 'spreadsheet'
  }
  return undefined
}

/**
 * Classify for download-menu branching.
 * Prefers filename extension when present so PDF rendition markers
 * (type=PDF with report.docx) still select the Office menu.
 */
export function getDownloadDocumentKind(
  documentType: string | undefined,
  filename?: string
): DownloadDocumentKind {
  return (
    kindFromToken(extensionFromFilename(filename)) ??
    kindFromToken(documentType) ??
    'other'
  )
}

export function isOfficeDownloadKind(
  kind: DownloadDocumentKind
): kind is 'word' | 'powerpoint' | 'spreadsheet' {
  return kind === 'word' || kind === 'powerpoint' || kind === 'spreadsheet'
}
